export default {
    CHECKOUT: 'checkout',
    CHECKOUT_WITHOUT_TRANSACTION: 'checkout-without-transaction',
    CHECKOUT_SOFT_LOGIN_MODAL: 'checkout-soft-login-modal',
    CHECKOUT_VALUE: 'checkout-value',
    GREETINGS: 'greetings',
    FREE_COINS_POPUP: 'free-coins-popup',
    LAST_CHECKOUT_ID: 'last-checkout-id',
    COLLECT_COINS: 'collect-coins',
    FREE_COINS_REMIND_CHECKOUT: 'free-coins-remind-checkout',
    GUEST: 'guest',
    TRANSACTION_TOKEN: 'transaction-token',
    BUSINESS_REFERRAL_LINK_ID: 'businessReferralLinkId',
    TOKEN: 'token',
    CUSTOMER: 'customer',
    AUTH_SOFT_LOGIN: 'twism__auth-soft-login'
};
